import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
export const callWebMethod = createRESTModule((restModuleOpts) => {
    return async ({ baseURL, filename, method, args }) => {
        const response = await restModuleOpts.fetchWithAuth(`${baseURL}/_webMethods/${filename}/${method}.ajax`, {
            body: JSON.stringify(args),
            method: 'POST',
        });
        const json = await response.json();
        // request failed
        if (json.exception === true) {
            throw json.result;
        }
        return json.result;
    };
});
